import '../snippets/product-gallery.js';
import { getOmnibusPriceFromAPI, renderOmnibusPriceFromAPI } from '../vendor/omnibus.js';

$(function() {
  const automationTestSpecialPriceSelector = '[data-product-special-price]';
  const automationTestBasePriceSelector = '[data-product-base-price]';
  $('.product-template').on('variantChange', function (e) {
    if (e.variant) {
      //automation test
      let priceValue = e.variant.price;
      let compareAtPriceValue = e.variant.compare_at_price;


      let basePriceValue, specialPriceValue;
      if (compareAtPriceValue > priceValue) {
        specialPriceValue = Math.floor(priceValue / 100);
        basePriceValue = Math.floor(compareAtPriceValue / 100);
      } else {
        specialPriceValue = '';
        basePriceValue = Math.floor(priceValue / 100);
      }

      document
        .querySelectorAll(automationTestSpecialPriceSelector)
        .forEach((priceTag) => {
          priceTag.setAttribute('data-product-special-price', specialPriceValue);
        });

      document
        .querySelectorAll(automationTestBasePriceSelector)
        .forEach((priceTag) => {
          priceTag.setAttribute('data-product-base-price', basePriceValue);
        });


      $('[data-variant-sku]').html(e.variant.sku);
      renderOmnibusPrice(e.variant.id, e.variant.price);

      if (!e.variant.available) {
        $('.klaviyo-bis-trigger').show();
        $('.product__form__submit #add_to_cart').html(theme.strings.soldOut);

         if ($('.no-notify').length <= 0) {
            $('.product__form__submit #add_to_cart').hide();
         }else {
            $('.product__form__submit #add_to_cart').show();
            $('.product__form__submit #add_to_cart').addClass('disabled');
         }

      } else {
        $('.klaviyo-bis-trigger').hide();
        $('.product__form__submit #add_to_cart').html(theme.strings.addToCart);
        $('.product__form__submit #add_to_cart').show();
        $('.product__form__submit #add_to_cart').removeClass('disabled');

      }
    }
  });

  const initTemplate = () => {
    const variantID = document.getElementById('omnibusprice').dataset.omnibus_id;
    const variantPrice = document.getElementById('omnibusprice').dataset.variant_price;
    renderOmnibusPrice(variantID, variantPrice);
  };

  const renderOmnibusPrice = async (variantID, variantPrice) => {
    const omnibusContainer = document.getElementById('omnibusprice');
    const brand = document.getElementById('omnibusprice').dataset.omnibus_brand;
    const hasPromo = document.getElementById('omnibusprice').dataset.promo;
    renderOmnibusPriceFromAPI(omnibusContainer, await getOmnibusPriceFromAPI(brand, variantID), variantPrice, hasPromo);
  };

  initTemplate();
});
